export const sectsData = {
  camarilla: {
    id: 'camarilla',
    name: 'Camarilla',
    summary:
      'A Torre de Marfim dos vampiros civilizados. A Camarilla protege a Máscara, controla a sociedade mortal pelas sombras e mantém uma rígida hierarquia.',
    politics: {
      hierarchy: 'Príncipe (cidade), Senescal, Xerife, Arqué, Primigênie, Chicote, Guardião do Édito.',
      tenets: 'Defesa intransigente da Máscara, obediência às Tradições, domínio discreto sobre mortais.'
    },
    influences:
      'Corporativo, bancário, judiciário, mídia tradicional e instituições culturais. Preferência por influência institucional e estabilidade.',
    ethos:
      'Ordem, tradição e manutenção do status quo. A lealdade à seita supera rivalidades de clã.',
    relationships:
      'Hostil ao Sabbat; relação tensa com Anarquistas. Tolerância calculada aos Independentes quando convém.',
    notablePractices: 'Cortes, elísios, boatos e política de salão. Subterfúgio e etiqueta são armas tão letais quanto presas.',
    laws: [
      'A Máscara: Proteja o segredo da existência vampírica a qualquer custo.',
      'Domínio: Respeite a autoridade do Príncipe e dos senhores de domínio.',
      'Prole: Não crie novos vampiros sem permissão.',
      'Responsabilidade: O Criador é responsável por sua prole.',
      'Hospitalidade: Apresente-se ao Príncipe ao chegar a uma nova cidade.',
      'Destruição: A execução final cabe à autoridade estabelecida.'
    ],
    roles: [
      { title: 'Príncipe', description: 'Governante de uma cidade, árbitro das Tradições e da política local.' },
      { title: 'Senescal', description: 'Braço direito do Príncipe, assume comando na sua ausência.' },
      { title: 'Xerife', description: 'Enforça as leis, conduz investigações e aplica punições.' },
      { title: 'Primigênie', description: 'Conselho de anciões que representam os clãs da cidade.' },
      { title: 'Chicote', description: 'Liaison entre o clã e sua liderança, conduzindo disciplina interna.' },
      { title: 'Guardião do Elísio', description: 'Mantém a paz em locais sagrados para a Camarilla (Elísios).' }
    ],
    rituals: [
      'Elísio: Reuniões formais com regras rígidas de etiqueta e não violência.',
      'Apresentação: Neonatos se apresentam ao Príncipe e recebem reconhecimento.',
      'Debut de Clã: Cerimônias internas para promoção e reconhecimento.'
    ]
  },
  sabbat: {
    id: 'sabbat',
    name: 'Sabbat',
    summary:
      'A Espada de Caim. Rejeita a hipocrisia da Máscara, abraça a Besta e busca superar a humanidade, forjando uma irmandade de monstros.',
    politics: {
      hierarchy: 'Arcebispo, Bispos, Prisci; bandos liderados por Ductus e guiados por Sacerdotes.',
      tenets: 'Lealdade ao bando e à Espada. Rituales e Vaulderie unem os membros.'
    },
    influences:
      'Submundo, tráfico, cultos e zonas de conflito. Preferem domínios caóticos e zonas cinzentas.',
    ethos:
      'Ascensão através do poder e do terror. A liberdade vem do rompimento com a humanidade.',
    relationships:
      'Inimigos declarados da Camarilla. Desdém pelos Anarquistas. Relações utilitárias com Independentes.',
    notablePractices: 'Caçadas de sangue, Vaulderie, rituais de iniciação brutais e cruzadas contra Anciãos.',
    laws: [
      'Lealdade ao Bando: O bando é a família e a lei imediata.',
      'Superação da Humanidade: Abraçar a Besta; a humanidade é fraqueza.',
      'Ritae: Rituais e cerimônias definem identidade e coesão.'
    ],
    roles: [
      { title: 'Arcebispo', description: 'Autoridade regional sobre múltiplos bandos e cidades.' },
      { title: 'Bispo', description: 'Liderança religiosa/política local, define ritae e doutrina.' },
      { title: 'Prisci', description: 'Anciões conselheiros que influenciam rumos da seita.' },
      { title: 'Ductus', description: 'Líder de um bando específico.' },
      { title: 'Sacerdote', description: 'Guia espiritual do bando, conduza ritae e Vaulderie.' }
    ],
    rituals: [
      'Vaulderie: Laço de sangue comunal que fortalece a irmandade do bando.',
      'Monomacia: Duelo ritual para resolver disputas de honra e liderança.',
      'Criação: Ritos brutais de iniciação e quebra de identidade mortal.'
    ]
  },
  anarquistas: {
    id: 'anarquistas',
    name: 'Movimento Anarquista',
    summary:
      'Liberdade contra tradições engessadas. Comunidades autônomas que rejeitam o autoritarismo das seitas hegemônicas.',
    politics: {
      hierarchy: 'Estruturas horizontais, assembleias e lideranças locais. Barões e conselhos comunitários em algumas cidades.',
      tenets: 'Autodeterminação, transparência, solidariedade entre cainitas e defesa da comunidade.'
    },
    influences:
      'Movimentos sociais, cultura alternativa, tecnologia, redes comunitárias e criminalidade de baixa escala.',
    ethos:
      'Pragmatismo e liberdade. A ordem deve servir às pessoas, não o contrário.',
    relationships:
      'Conflito frequente com a Camarilla. Resistência ativa contra incursões do Sabbat. Abertos a pactos com Independentes.',
    notablePractices: 'Coletivos, abrigos, rádios livres, redes de apoio e táticas de guerrilha urbana.',
    laws: [
      'Mandatos Locais: Regras definidas por assembleia e validadas pela comunidade.',
      'Transparência: Decisões e recursos devem ser transparentes.',
      'Autodefesa: Defesa do território e da comunidade em primeiro lugar.'
    ],
    roles: [
      { title: 'Barão/Baronesa', description: 'Figura de coordenação em domínios anarquistas, legitimada pela comunidade.' },
      { title: 'Conselho Local', description: 'Representantes de células e coletivos; delibera políticas e media conflitos.' },
      { title: 'Facilitador', description: 'Orienta processos de assembleia e mediação.' }
    ],
    rituals: [
      'Círculos: Reuniões abertas para decisões coletivas.',
      'Juramentos Comuns: Compromissos públicos com a comunidade.',
      'Ritos de Acolhida: Apresentação de novos membros à rede local.'
    ]
  },
  independentes: {
    id: 'independentes',
    name: 'Clãs Independentes',
    summary:
      'Clãs e cultos não alinhados às grandes seitas, guiados por agendas próprias e alianças circunstanciais.',
    politics: {
      hierarchy: 'Variante por clã: sociedades secretas, famílias mafiosas, cultos religiosos.',
      tenets: 'Autonomia, segredo e autopreservação; negócios antes de bandeiras.'
    },
    influences:
      'Mercados paralelos, ocultismo, religiões de mistério, redes familiares e comércio internacional.',
    ethos:
      'Pragmatismo e tradição particular. Lealdade costuma ser interna ao clã.',
    relationships:
      'Negociam com todos. Evitam compromissos ideológicos profundos com Camarilla, Sabbat ou Anarquistas.',
    notablePractices: 'Contratos, juramentos secretos, mercantilismo sobrenatural e cultos iniciáticos.',
    laws: [
      'Autonomia de Clã: As regras variam de acordo com a tradição interna.',
      'Sigilo: Proteção das práticas e negócios do clã acima de tudo.',
      'Contrato: A palavra empenhada rege relações e disputas.'
    ],
    roles: [
      { title: 'Patriarca/Matriarca (Giovanni/Hecata)', description: 'Chefias familiares e conselhos financeiros/necromânticos.' },
      { title: 'Assamitas/Banu Haqim – Qadi', description: 'Juízes e intérpretes da lei de clã.' },
      { title: 'Ministério – Sacerdotes', description: 'Estruturas de culto e iniciação.' }
    ],
    rituals: [
      'Pactos e Juramentos: Acordos formais que regem negócios e alianças.',
      'Ofícios e Cultos: Cerimônias específicas de cada tradição/clã.',
      'Ritos de Passagem: Iniciações internas e provas de lealdade.'
    ]
  }
}

export default sectsData
